import { render, staticRenderFns } from "./CurLivTechnologyPage.vue?vue&type=template&id=869b4fdc&scoped=true&"
import script from "./CurLivTechnologyPage.vue?vue&type=script&lang=js&"
export * from "./CurLivTechnologyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869b4fdc",
  null
  
)

export default component.exports